import(/* webpackMode: "eager" */ "/app/src/app/(auth)/components/PasswordResetForm.tsx")